import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useListBoxSection } from '@react-aria/listbox';
import classNames from 'classnames';
import styles from './Dropdown.module.scss';
export const DropdownOptionGroup = ({ ariaLabel, children, title, }) => {
    const { itemProps, groupProps } = useListBoxSection({
        'aria-label': ariaLabel,
    });
    return (_jsxs("li", { ...itemProps, className: "p-0", children: [_jsx("div", { className: classNames(styles.groupLabel, 'fw-semibold px-2x py-0-5x'), children: title }), _jsx("ul", { className: "px-0", ...groupProps, children: children })] }));
};
